import { Component, Input } from '@angular/core';

import { SmartModalService } from '../../../core/services/smart-modal.service';

@Component({
    selector: 'itpx-simple-info',
    template: `
        <p *ngIf="!data.html">{{data.text | translate}}</p>
        <div *ngIf="data.html" [innerHTML]="data.text | translate | keepHtml"></div>
        <div class="row">
            <div class="{{data.btnPosition ? 'align-center' : 'pull-right'}}">
                <div class="button-form col-md-12">
                    <button type="button" (click)="onYes()" class="btn {{data.btn}}">
                        {{ data.btnYesText ? data.btnYesText :  'OK'}}
                    </button>
                    <!-- <button type="button" (click)="onNo()" class="btn btn-default">
                        {{ data.btnNoText ? data.btnNoText :  'Cancel'}}
                    </button>-->
                </div>
            </div>
        </div>
    `,
    styleUrls: ['./modal.component.css']
    
})
export class SimpleAlertComponent {

    @Input()
    private data: any;

    constructor(private modalService: SmartModalService) { }

    private onYes() {
        this.modalService.sendResult(true);
    }

    // private onNo() {
    //     this.modalService.sendResult(null);
    // }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/modal/simple-alert.component.ts